import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formatISO } from "date-fns";
import { MdEdit } from "react-icons/md";
import {
  SelectedAccount,
  UserDetails,
  addAccountPriority,
  cancelAsset,
  cancelRiskLevelData,
  getCalculationBalance,
  selectAccount,
} from "../../redux/userSlice";
import icon4 from "../../assets/images/icon4.svg";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const SelectedAccountComponent = ({
  AccountStatus_function,
  RiskManagementModal,
  accounts
}) => {
  const APi_Url = process.env.REACT_APP_ENIGMA_API;
  const dispatch = useDispatch();
  const userDetails = useSelector(UserDetails);
  const selectedAccountDetails = useSelector(SelectedAccount);
  // const [accounts, setAccounts] = useState([]);

  const [accountModal, setaccountModal] = useState(false);
  const token = userDetails?.token;

  // useEffect(() => {
  //   showAccounts();
  // }, []);

  // const showAccounts = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${APi_Url}api/account/get-all-source-account/${userDetails.id}`,

  //       {
  //         headers: {
  //           Accept: "application/json",
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     setAccounts(response.data.response);

  //     if (response.data && !selectedAccountDetails) {
  //       dispatch(
  //         selectAccount({
  //           account: {
  //             accountId: response.data.response[0].sourceAccountId,
  //             accountName: response.data.response[0].accountName,
  //             accountStatus: response.data.response[0].status,
  //           },
  //         })
  //       );
  //     }

  //     // Handle response data as needed
  //   } catch (error) {
  //     console.error("Error ", error);
  //   }
  // };

  const today = new Date();
  const createdDate = formatISO(today);

  // acoount create validation and from submit start
  const initialValues = {
    accountName: "",
    displayPriority: 1,
  };

  const validationSchema = Yup.object({
    accountName: Yup.string()
      .min(3, "Account name must be at least 3 characters")
      .required("Account name is Required"),
  });

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  const onSubmit = async (values, { setSubmitting, resetForm }) => {
    const data = {
      accountName: capitalizeFirstLetter(values.accountName),
      displayPriority: 1,
      createdDate: createdDate,
      userId: userDetails.id,
      createdBy: userDetails.id,
      deletedDate: createdDate,
      deletedBy: 0,
    };

    //  "#accountModal".modal("hide");
    // isDeleted: true,

    try {
      const response = await axios.post(
        `${APi_Url}api/account/create-source-account`,
        data,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Successfully add account");
      // showAccounts();
      setaccountModal(false);
      resetForm();
    } catch (error) {
      console.error("Error ", error);
    } finally {
      setSubmitting(false); // Make sure to reset form state, if applicable
    }
  };

  // acoount create validation and from submit end
  return (
    <div className="dropdown">
      <button
        className="btn dropdown-toggle form-select"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {selectedAccountDetails
          ? selectedAccountDetails.accountName
          : "Select account"}
      </button>
      <ul className="dropdown-menu">
        {accounts?.map((account) => (
          <li key={account.sourceAccountId} className="account-listing">
            <div
              onClick={() => {
                // setSelectdAccount({
                //   accountId: account.sourceAccountId,
                //   accountName: account.accountName,
                // })
                dispatch(
                  selectAccount({
                    account: {
                      accountId: account.sourceAccountId,
                      accountName: account.accountName,
                      accountStatus: account.status,
                    },
                  })
                );
                dispatch(addAccountPriority(''));
                // dispatch(cancelAsset());
                // dispatch(cancelRiskLevelData());

                if (AccountStatus_function) {
                  AccountStatus_function();
                }
                // Show_MoneyManagement();
              }}
            >
              <Link className="dropdown-item" to="#">
                {account.accountName}
              </Link>
            </div>

            <img
              src={icon4}
              alt="addicon"
              className="modal_img"
              onClick={() => {
                
                dispatch(
                  selectAccount({
                    account: {
                      accountId: account.sourceAccountId,
                      accountName: account.accountName,
                      accountStatus: account.status,
                    },
                  }),
                
                );

              dispatch(addAccountPriority('update'));
                RiskManagementModal(true);
              }}
            />
          </li>
        ))}

        <li>
          <Link
            className="add_accountbtn"
            to="#"
            onClick={() => {
              // setaccountModal(true);
              RiskManagementModal(true);
              dispatch(addAccountPriority("add"));
            }}
          >
            add account
          </Link>
        </li>
      </ul>
      {/* for account modal */}
      <div
        className={`modal fade inputmodal ${accountModal ? "show" : ""}`}
        aria-hidden="true"
        style={{ display: accountModal ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1>Account</h1>
            </div>
            <div className="modal-body">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {({ isSubmitting, isValid, dirty, setFieldValue }) => (
                  <Form className="row needs-validation">
                    <div className="col-md-12">
                      <div className="row mb-3">
                        <label className="col-sm-5 col-form-label">
                          Account Name
                        </label>
                        <div className="col-sm-7">
                          <Field
                            type="text"
                            id="accountName"
                            name="accountName"
                            placeholder="Input here"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="accountName"
                            component="div"
                            className="error_msg"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <button className="btn kevlar_btn" type="submit">
                        Submit
                      </button>
                    </div>
                    <div className="col-12">
                      <button
                        className="btn kevlar_btn"
                        type="button"
                        onClick={() => {
                          setaccountModal(false);
                          setFieldValue("accountName", "");
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectedAccountComponent;
